var styles = {"box":"FormGroup_box_ttgga_1","no-mobile-scroll":"FormGroup_no-mobile-scroll_ttgga_13","box__inner":"FormGroup_box__inner_ttgga_20","scroll":"FormGroup_scroll_ttgga_30"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
